import { defineStore } from 'pinia';
import api from "@/api/axios";

export const useListadosEntidadesStore = defineStore('listadosEntidades', {
    state: () => ({
        industrias: [],
        martilleros: [],
        modalidadesSubastas: [],
        paises: [],
        provincias: [],
        terminosCondiciones: [],
        tipificados: [],
        tiposArchivos: [],
        tiposCreditos: [],
        historialOfertas: [],
        categorias: [],
        categoriasTipificados: []
    }),
    actions: {
        getCategorias(params = {}) {
            return api
                .get(`/categorias`, { params })
                .then((response) => { this.categorias = response.data });
        },
        getCategoriasTipificados(subasta_id, params = {}) {
            return api
                .get(`/categorias/tipificados/${subasta_id}`, { params })
                .then((response) => { this.categoriasTipificados = response.data });
        },
        getIndustrias(params = {}) {
            return api
                .get(`/industrias`, { params })
                .then((response) => { this.industrias = response.data });
        },

        getProvincias(params = {}) {
            return api
                .get(`/provincias`, { params })
                .then((response) => { this.provincias = response.data });
        },
        async getTiposArchivos(params = {}) {
            // Importante: este recurso vive en /api (no /website)
            const base = process.env.VUE_APP_API_URL;
            const url = `${base}/api/tipos-archivos`;

            const response = await api.get(url, { params });
            const raw = response?.data;
            const list = Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : [];
            this.tiposArchivos = list;
            return response;
        },
       
    },
    getters: {

    },
});